import React, {useState} from "react";
import help_img from "../img/information-line.png"
import logo_eco from "../img/Logo eco by assur bon plan.png"
import DataDevis from "../dataDevis";
import logo_abp from "../img/Logo assur bon plan.png"
import question_mark from "../img/questionmark.png"

const OptionRow = (p) => {

    const {xena,periodicite,formule,changeParams,selectedOptions,detailSwitch} = p.container
    let w = xena.find( w => w.Z_CODOPT==p.xenaKey )
    if (( p.xenaKey == 'AC1' || p.xenaKey == 'AC2' )&&( formule == 'M2' )) w = undefined

    const checked = selectedOptions.includes(p.xenaKey)
    const sollyChecked = false

    const onChange = ()=>{
        let s = selectedOptions
        // Prevent IPx and ACx to be selected at once
        switch ( p.xenaKey ) {
            case 'IP1':
                s = s.filter( e => e!='IP2' )
                break;
            case 'IP2':
                s = s.filter( e => e!='IP1' )
                break;
            case 'AC1':
                s = s.filter( e => e!='AC2' )
                break;
            case 'AC2':
                s = s.filter( e => e!='AC1' )
                break;
        }
        if ( s.includes(p.xenaKey) ) {
            changeParams( {selectedOptions:s.filter( e=>e!=p.xenaKey ) } )
        } else {
            changeParams( {selectedOptions: [...s,p.xenaKey] } )
        }
    }

    return <tr><td onClick={(e)=> { detailSwitch(p.xenaKey) ; e.stopPropagation() }}>{p.children}
    </td><td 
        className={( checked &&( periodicite=='A' )) ? 'tarif selected' : 'tarif'}
        onClick={onChange}
    >
    { w ? <>{DataDevis.fancyPrice(w.Z_MTAOP)} € 
        </> :<i>Non disponible</i>}
    </td><td 
        className={( checked &&( periodicite=='M' )) ? 'tarif selected' : 'tarif'}
        onClick={onChange}
    >
    { w ? <>{DataDevis.fancyPrice(w.Z_MTMOP)} € 
        </> :<i>Non disponible</i>}
    </td>
    </tr>
}


const DetailRow = (p) => {
    return p.unfold.includes(p.xenaKey) ? <tr><td className="formule_details" colSpan={p.oneColumn?2:3}>{p.children}</td></tr> : <></>
}

export default (props) => {

    const [unfold,setUnfold] = useState([])

    const detailSwitch = (code)=>{
        if ( unfold.includes(code) ) {
            setUnfold( unfold.filter(c=>c!=code))
        } else {
            setUnfold([code,...unfold])
        }
    }
    const {devis,changeParams} = props.container
    const isMoto = devis.type == 'moto'
    const {params} = devis
    const {options,periodicite,formule,selectedOptions} = params
    const container = {
        xena:options,
        periodicite:periodicite,
        formule:formule,
        changeParams:changeParams,
        selectedOptions:selectedOptions || [],
        detailSwitch:detailSwitch
    }
    if ( ! options ) return <></>
    return <table className="comparateur onecolumn">
        <thead>
            <tr><th></th><th>Tarif TTC Annuel<br/>(x1)</th><th>Tarif TTC Mensuel<br/>(x12)</th></tr>
        </thead>
        <tbody>

            {isMoto?<>

            <tr><th colSpan="3">Assistance</th></tr>
            <OptionRow xenaKey="AST" container={container}>
                <h3>Assistance Plus 0 km + véhicule de remplacement
                <img src={question_mark}/></h3>

            </OptionRow>
            <DetailRow xenaKey="AST" unfold={unfold} >
            <p>Assistance pour l'assuré, son passager et son deux-roues, 24h/24 -
            7j/7, en cas de panne, accident, vol, tentative de vol ou crevaison, perte de
            clefs et enlèvement par la fourrière.
            Incluant un véhicule de remplacement (auto ou moto*) pour toute durée d’immobilisation
            supérieure à 48h (3 jours suite à une panne, 5 jours suite à un accident et 15 jours suite à
            un vol du véhicule).
            </p>
            </DetailRow>
            <tr><th colSpan="3">Assurance Individuelle Pilote</th></tr>
            <OptionRow xenaKey="IP1" container={container}>
                <h3>Jusqu'à 300 000 €
                <img src={question_mark}/></h3>
                <b>Nous vous <u>recommandons</u> cette option !</b>
            </OptionRow>
            <DetailRow xenaKey="IP1" unfold={unfold} >
                <p>Garantie du versement d’indemnités à vous ou à vos ayants droit en cas d’accident au guidon de votre deux-roues à hauteur de 300000€. 
                </p>
            </DetailRow>
            <OptionRow xenaKey="IP2" container={container}>
                <h3>Jusqu'à 800 000 €
                <img src={question_mark}/></h3>

            </OptionRow>

            <DetailRow xenaKey="IP2" unfold={unfold} >
            <p>Assurance pilote à hauteur de 800000€. 
            </p>
            </DetailRow>
            <tr><th colSpan="3">Assurance accessoire</th></tr>
            <OptionRow xenaKey="AC1" container={container}>
                <h3>Jusqu'à 1 000 €
                <img src={question_mark}/></h3>

            </OptionRow>

            <DetailRow xenaKey="AC1" unfold={unfold} >
            <p>Garantie du remboursement des accessoires hors-série et équipement vestimentaire de protection du motard jusqu’à 1000 €. Remboursement à la valeur d’achat pour les véhicules acquis neufs depuis moins de 18 mois. </p>
            </DetailRow>
            <OptionRow xenaKey="AC2" container={container}>
                <h3>Jusqu'à 10 000 €
                <img src={question_mark}/></h3>

            </OptionRow>

            <DetailRow xenaKey="AC2" unfold={unfold} >
            <p>Assurance Accessoires jusqu’à 10000€. Remboursement à la valeur d’achat pour les véhicules acquis neufs depuis moins de 18 mois. 
            </p>
            </DetailRow>
            </>:<>


            <tr><th colSpan="3">Assistance</th></tr>
            <OptionRow xenaKey="AST" container={container}>
                <h3>Assistance Plus 0 km + véhicule de remplacement
                <img src={question_mark}/></h3>

            </OptionRow>
            <DetailRow xenaKey="AST" unfold={unfold} >
            <p>Assistance sans franchise kilométrique, en France métropolitaine et dans la plupart des pays d'Europe (en cas de panne, d'accident,
de tentative de vol, de vol, de crevaison, de perte/vol/casse/enfermement de clés ou d'enlèvement par la fourrière) pour votre véhicule,
vous et votre famille, en voyage, ensemble ou séparément.
Véhicule de remplacement pour une durée d'immobilisation supérieure à 48h. Forfait remorquage sur autoroute et voies express dans la limite de 300 Euros.
            </p>
            </DetailRow>

            <OptionRow xenaKey="IP" container={container}>
                <h3>Assurance Conducteur
                <img src={question_mark}/></h3>

            </OptionRow>
            <DetailRow xenaKey="IP" unfold={unfold} >
            <p>Vous garantit lors d'un accident corporel au volant de votre véhicule.
Plafond et limites de garanties (déduction faite des sommes allouées par les organismes sociaux et assimilés) :
. En cas de décès, la Compagnie prend en charge le préjudice économique du conjoint (non séparé de corps ou divorcé) ou concubin (justifiant d'une vie
commune notoire) et/ou des enfants à charge fiscalement dans la limite de 150000 EUR et les frais d'obsèques jusqu'à 5000 EUR.
. En cas de déficit fonctionnel permanent supérieur à 10%, la Compagnie garantit le versement d'une indemnité déterminée selon les règles du droit commun
dans la limite de 800000 EUR, le remboursement des frais médicaux restés à charge dans la limite de 10000 EUR , les frais de tierce personne dans la
limite de 90000 EUR et les pertes de revenus dans la limite de 100000 EUR.
            </p>
            </DetailRow>

            <OptionRow xenaKey="EOA" container={container}>
                <h3>Garantie des Accessoires Hors Série et Contenu
                <img src={question_mark}/></h3>

            </OptionRow>
            <DetailRow xenaKey="EOA" unfold={unfold} >
            <p>Vous permet, en complément des garanties vol, incendie ou dommages à votre véhicule, de bénéficier de l'extension de la garantie aux
accessoires hors série et au contenu à concurrence de 600 EUR.
- Accessoires : tout élément d'enjolivement, d'amélioration, ou de sécurité, ne figurant pas au catalogue du constructeur comme équipement optionnel,
non essentiel au fonctionnement du véhicule assuré, fixé ou non à demeure dans ou sur ledit véhicule.
- Contenu : les vêtements et objets personnels contenus dans le véhicule assuré à l'exclusion de l'argenterie, des bijoux, fourrures, billets de banque,
titres, espèces, valeurs et marchandises transportées.
            </p>
            </DetailRow>

            </>}

        </tbody>
    </table>
}